import React from "react";
import "./Visit_btn.css";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
function Visit_btn({btn_text,onClick}) {
  return (
    <>
      <section className="Visit_btn_holder" onClick={onClick}>
        <Button className="visit_btn" type="button">{btn_text} <FontAwesomeIcon icon={faArrowRight} /></Button>
      </section>
    </>
  );
}

export default Visit_btn;
